export const GET_COMMONTYPE_STARTED = "GET_COMMONTYPE_STARTED";
export const GET_COMMONTYPE_COMPLETED = "GET_COMMONTYPE_COMPLETED";
export const GET_COMMONTYPE_FAILED = "GET_COMMONTYPE_FAILED";

export const GETALL_COMMONTYPE_STARTED = "GETALL_COMMONTYPE_STARTED";
export const GETALL_COMMONTYPE_COMPLETED = "GETALL_COMMONTYPE_COMPLETED";
export const GETALL_COMMONTYPE_FAILED = "GETALL_COMMONTYPE_FAILED";

export interface ICommontype {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    aarolesInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    autoid: number;
    isLoading: boolean;
    error: string;
}


export const getCOMMONTYPEList = (autoid) => {
  // alert("actions getCOMMONTYPEList");
    return {
        type: GET_COMMONTYPE_STARTED ,
        payload: 'Value',
        input:autoid
    };
};

export const getAllCOMMONTYPEList = (commonValue) => {
      return {
          type: GETALL_COMMONTYPE_STARTED ,
          payload: 'Value',
          input:commonValue 
         
      };
  };